<template>
  <div class="shop-coupon-modal">
    <div class="coupon-part">
      <h3 v-html="coupon.name"></h3>
      <div class="coupon-description-wrapper" v-if="coupon.description">
        <div class="coupon-description">{{ !showDescription && coupon.description.length > 80 ? `${coupon.description.substr(0, 80)}...` : coupon.description }}</div>
        <div class="coupon-description-buttons" v-if="coupon.description.length > 80">
          <button v-if="!showDescription" @click="toggleDescription">
            {{ $t('Читать подробнее') }}
            <icon-base :width="20" :height="20"><icon-chevron-down></icon-chevron-down></icon-base>
          </button>
          <button v-if="showDescription" @click="toggleDescription">
            {{ $t('Меньше') }}
          </button>
        </div>
      </div>
      <div v-if="isReferrer" @click="showCoupon(coupon)">
        <button class="coupon-button-mock">
          <span :class="['button-text', { 'button-promo' : coupon.type === 'promo', 'button-action': coupon.type !== 'promo' }]">
            {{ coupon.type === 'promo' ? $t('Показать код') : $t('Получить скидку') }}
          </span>
          <span class="button-fake-promo" v-if="coupon.promocode">{{ coupon.promocode.slice(-10) }}</span>
        </button>
      </div>
      <div v-else>
        <span class="coupon-code-hint">{{ $t('Скопируйте и вставьте этот код на') }} {{ coupon.link }}</span>
        <div class="coupon-code-wrapper">
          <input class="coupon-code-input" type="text" :value="coupon.promocode || $t('Промокод не нужен')" readonly>
          <button class="coupon-code-button button-primary" :disabled="!coupon.promocode" @click="copyToClipboard(coupon.promocode)">{{ $t(buttonText) }}</button>
        </div>
      </div>
      <div class="coupon-button-wrapper">
        <a class="coupon-button button-secondary" :href="shopLink">{{ $t('Перейти в магазин') }}</a>
      </div>
      <div class="coupon-poll" v-if="!voted">
        <span>{{ $t('Промокод сработал') }}?</span>
        <button class="coupon-poll-answer" @click="vote" data-answer="vote_yes">
          <icon-base width="20" height="20"><icon-thumb-up-x/></icon-base>
          {{ $t('Да') }}
        </button>
        <button class="coupon-poll-answer" @click="vote" data-answer="vote_no">
          <icon-base width="20" height="20"><icon-thumb-down-x/></icon-base>
          {{ $t('Нет') }}
        </button>
      </div>
      <div class="coupon-poll" v-if="voted">{{ $t('Ваш голос учтен, спасибо') }}</div>
    </div>
    <div class="cashback-part">
      <!--noindex-->
      <p>{{ $t('Получите до') }}
        <span class="cashback-count" v-if="coupon.cashbe_value">{{ coupon.cashbe_value }} {{ coupon.cashbe_type === 'percent' ? '%' : 'руб.' }}</span>
        <span class="cashback-count" v-else>10%</span>
        {{ $t('кэшбэка дополнительно') }}
      </p>
      <a class="button-secondary" :href="`/go/cashbe/${coupon.shop_id}/authbutton/`" rel="nofollow">{{ $t('Получить') }}</a>
      <!--noindex-->
    </div>
    <button class="close-button-modal" @click="close"><icon-base><icon-close/></icon-base></button>
  </div>
</template>

<script>
import axios from 'axios';
import IconBase from '../IconBase.vue';
import IconClose from '../icons/IconClose.vue';
import IconThumbDownX from '../icons/IconThumbDownX.vue';
import IconThumbUpX from '../icons/IconThumbUpX.vue';
import IconChevronDown from '../icons/IconChevronDown.vue';
import IconChevronUp from '../icons/IconChevronUp.vue';

export default {
  name: 'shop-coupon-modal',

  components: {
    IconBase,
    IconClose,
    IconThumbDownX,
    IconThumbUpX,
    IconChevronDown,
    IconChevronUp
  },

  props: {
    coupon: Object,
    currentLocale: String,
    ownHost: String
  },

  data() {
    return {
      voted: false,
      copied: false,
      isReferrer: false,
      showDescription: false
    }
  },

  computed: {
    buttonText() {
      return this.copied ? 'Скопировано' : 'Копировать';
    },

    shopLink() {
      let link = `/go/coupon/${this.coupon.coupon_id}`;
      return this.currentLocale !== 'ru' ? `/${this.currentLocale}${link}` : link;
    }
  },

  mounted() {
    this.isReferrer = true;
    if (!document.referrer) {
      return;
    }
    var referrerUrl = document.createElement('a');
    referrerUrl.href = document.referrer;
    if (referrerUrl.hostname && referrerUrl.hostname === this.ownHost) {
        this.isReferrer = false;
    }
  },

  methods: {
    toggleDescription() {
      this.showDescription = !this.showDescription;
    },

    copyToClipboard(str) {
      const el = document.createElement('textarea');
      el.value = str;
      el.setAttribute('readonly', '');
      el.style.position = 'absolute';
      el.style.left = '-9999px';
      document.body.appendChild(el);
      const selected =
        document.getSelection().rangeCount > 0
          ? document.getSelection().getRangeAt(0)
          : false;
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      if (selected) {
        document.getSelection().removeAllRanges();
        document.getSelection().addRange(selected);
      }
      this.copied = true
    },

    async vote(e) {
      const { answer } = e.currentTarget.dataset;
      await axios.post(this.eventUrl(), { store: this.coupon.slug, coupon_id: this.coupon.coupon_id, event: answer });
      this.voted = true;
    },

    close() {
      this.$emit('close');
    }
  }
}
</script>

<style scoped>
.button-fake-promo {
  display: block;
  padding: 0 5px;
  color: #666872;
  font-size: 18px;
  text-align: right;
  text-transform: uppercase;
}

.coupon-button-mock {
  position: relative;
  display: inline-block;
  margin: 18px 0 10px 0;
  border: 1px solid #dbdce1;
  border-radius: 3px;
  padding: 0;
  font-size: 16px;
  width: 218px;
  height: 60px;
  line-height: 1;
  cursor: pointer;
  background-color: #fff;
}

.button-text {
  position: absolute;
  top: -1px;
  left: -1px;
  bottom: -1px;
  right: -1px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 3px;
  min-height: 100%;
  font-weight: bold;
  text-align: center;
  color: #ffffff;
  background-color: #eb3054;
}

.coupon-button-mock:hover .button-text {
  background-color: #b62946;
}

.coupon-button-mock:active .button-text {
  background-color: #2c316b;
}

.button-text.button-promo {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  right: 25px;
}

.button-text.button-promo::before {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  background: linear-gradient(to left bottom,transparent 50%,#ffb5c4 0,#ffa8b9) 100% 0 no-repeat;
  width: 28px;
  height: 60px;
  transform: translate(1px,4px) rotate(25deg);
  transform-origin: bottom right;
}

.shop-coupon-modal {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 660px;
}

.coupon-part {
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 1px solid #dbdce1;
  border-radius: 3px;
  width: 100%;
  background-color: #fafafb;
  z-index: 1;
}

.coupon-part h3 {
  margin: 40px 100px 25px;
  font-size: 21px;
  line-height: 30px;
  font-weight: bold;
  color: #061332;
  text-align: center;
}

.coupon-description-wrapper {
  padding: 0 20px 20px 20px;
  max-width: 600px;
  text-align: center;
  width: 100%;
}

.coupon-description-buttons button {
  display: flex;
  align-items: center;
  margin: 0 auto;
  border: none;
  padding: 0;
  background: transparent;
  color: #3c91e6;
  cursor: pointer;
}

.coupon-description-buttons button:hover {
  color: #29629c;
}

.coupon-description-buttons button:active {
  color: #2c316b;
}

.coupon-code-hint {
  font-size: 13px;
  color: #868993;
}

.coupon-code-hint a {
  text-decoration: underline;
}

.coupon-code-wrapper {
  display: flex;
  margin: 7px auto 30px;
}

.coupon-code-input {
  -webkit-appearance: none;
  -moz-appearance: none;
  border: 1px solid #dbdce1;
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
  border-right: none;
  padding: 0 25px;
  width: 100%;
  min-width: 0;
  height: 55px;
  max-width: 240px;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  color: #061332;
  background-color: #fff;
}

.coupon-code-button {
  border-radius: 0;
  border-top-right-radius: 3px;
  border-bottom-right-radius: 3px;
  padding: 0 25px;
  height: 55px;
}

.coupon-button-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 30px 40px;
  width: 100%;
  background-color: #ffffff;
}

.coupon-button {
  width: 100%;
  max-width: 265px;
}

.coupon-poll {
  border-top: 1px solid #dbdce1;
  padding: 15px 40px;
  width: 100%;
  text-align: center;
  font-size: 16px;
  line-height: 1.2;
  color: #868993;
  background-color: #ffffff;
}

.coupon-poll-answer {
  margin: 0 0 0 15px;
  border: none;
  padding: 0;
  font-size: 16px;
  color: #868993;
  background: transparent;
  cursor: pointer;
}

.coupon-poll-answer:hover {
  color: #3c91e6;
}

.coupon-poll-answer:active {
  color: #29629c;
}

.cashback-part {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: -2px 0 0 0;
  border: 1px solid #dbdce1;
  border-radius: 3px;
  padding: 25px;
  width: 90%;
  background-color: #fff0d9;
  text-align: center;
}

.cashback-part p {
  margin: 0 0 15px;
  font-size: 21px;
  text-align: center;
}

.cashback-part .cashback-count {
  font-weight: bold;
}

.cashback-part a {
  width: 100%;
  max-width: 285px;
}

.close-button-modal {
  background: transparent;
  border: none;
  position: absolute;
  right: 20px;
  top: 20px;
  color: #dbdce1;
  z-index: 1;
  cursor: pointer;
}

.close-button-modal:hover {
  color: #3c91e6;
}

.close-button-modal:active {
  color: #2c316b;
}

.cashback-part .button-secondary {
  display: inline-block;
  border: 2px solid #dc1e44;
  border-radius: 3px;
  padding: 15px 10px;
  text-align: center;
  font-size: 23px;
  color: #f8f8f8;
  background-color: #dc1e44;
  cursor: pointer;
  width: 100%;
  font-weight: 600;
}

.cashback-part .button-secondary:hover {
  background-color: #ee3a5f;
  border: 2px solid #ee3a5f;
}

@media (max-width: 767px) {
  .coupon-part h3 {
    margin: 50px 15px 25px;
    font-size: 18px;
    line-height: 24px;
  }

  .coupon-code-hint {
    font-size: 11px;
  }

  .coupon-code-wrapper {
    margin: 7px 10px 30px;
    font-size: 14px;
  }

  .coupon-code-input {
    padding: 0 10px;
  }

  .coupon-code-button {
    padding: 0 15px;
  }

  .coupon-button-wrapper {
    padding: 30px 10px;
  }

  .coupon-poll {
    padding: 15px 10px;
    font-size: 14px;
  }

  .coupon-poll-answer {
    margin: 0;
    font-size: 14px;
  }

  .cashback-part p {
    margin: 0 0 10px;
    font-size: 19px;
    line-height: 28px;
  }
}
</style>

